import React, { useContext, useState } from 'react';
import AuthenticateModal from '../HomeDeliveryNew/AuthenticateModal';
import _ from 'lodash';
import { BONUS_PRICE } from '../../constants/defaults';
import { AuthContext } from '../../Contexts';

const LoyaltyPricingBanner = () => {
  const userData = useContext(AuthContext)?.userData;
  const isLoggedIn = userData?.isLoggedIn;
  const [openSignupModal, setOpenSignupModal] = useState(false);

  const handleOpenSignUpModal = () => {
    setOpenSignupModal(true);
    _.triggerGTMVirtualPageViewEvent({
      event: 'drugPageBannerClick',
      loyaltySignupPath: 'Drug_page_banner'
    });
  };

  const handleCloseSignUpModal = () => {
    setOpenSignupModal(false);
  };

  return (
    <>
      {!isLoggedIn ? (
        <section>
          {openSignupModal && (
            <div className="mainModal afterSignupmodal">
              <div
                className="transparentBg"
                onClick={handleCloseSignUpModal}
              ></div>
              <div className="signUpModal">
                <AuthenticateModal
                  hideAuthenticateModal={handleCloseSignUpModal}
                />
              </div>
            </div>
          )}
          <div
            className="pricingSectionBanner themeFocus"
            tabIndex="0"
            onClick={handleOpenSignUpModal}
            onKeyDown={e => {
              if (e.key === 'Enter') handleOpenSignUpModal();
            }}
          >
            <img
              src="/content/images/icons/priceTagBlue.svg"
              className="priceTagImage desktop-only"
              alt=""
              height="32"
              width="32"
            />
            <p className="bannerText">
              Save an <span>extra ${BONUS_PRICE}</span> on any eligible
              prescription! <span>Sign up for free</span>
            </p>
          </div>
          <div
            className="pricingSectionBannerV2 themeFocus"
            tabIndex="0"
            onClick={handleOpenSignUpModal}
            onKeyDown={e => {
              if (e.key === 'Enter') handleOpenSignUpModal();
            }}
          >
            <img
              src="/content/images/icons/priceTagBlue.svg"
              className="priceTagImage desktop-only"
              alt=""
              height="32"
              width="32"
            />
            <p className="bannerText">
              Members can <span>save even more</span>
              <br className="mobile-only" /> and it's <span>free to join</span>
            </p>
          </div>
        </section>
      ) : (
        ''
      )}
    </>
  );
};

export default LoyaltyPricingBanner;
